import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from "./Navigation";
import {FaDoorClosed} from "react-icons/fa";
import {useSelector} from "react-redux";
import RoleSwitcher from "./RoleSwitcher";

const Header = () => {
    const authToken = useSelector(state => state.authentication.authToken) || localStorage.getItem('authToken')
    const email = useSelector(state => state.authentication.email)
    const userGroups = useSelector(state => state.authentication.userGroups)
    const selectedRole = useSelector(state => state.authentication.selectedRole)

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container-fluid">
                <Navigation />
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        {userGroups.length > 1 && selectedRole !== "" && (
                            <li className="nav-item">
                                <span className="nav-link">
                                    <RoleSwitcher userGroups={userGroups} doRedirect={true} />
                                </span>
                            </li>
                        )}
                        <li className="nav-item text-end text-md-start">
                            <span className="nav-link">
                            { authToken && email }
                            </span>
                        </li>
                        <li className="nav-item text-end text-md-start">
                            { authToken && <Link className="nav-link" to="/logout"><FaDoorClosed /></Link> }
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;
